import { Injectable } from '@angular/core'
import { ApiService } from './api.service'
import { environment } from '@env/environment'
import { BehaviorSubject, map, Observable } from 'rxjs'

@Injectable({
    providedIn: 'root',
})
export class SystemBannerService {
    private banner: string = null
    public bannerSubject = new BehaviorSubject<string>(null)

    constructor(private apiService: ApiService) {
        this.getSystemBanner()
    }

    private getSystemBanner(): void {
        this.apiService
            .getAnonymous(environment.api_url + 'banner-message')
            .pipe(
                map((resp) => {
                    this.banner = resp.message
                    this.bannerSubject.next(this.banner)
                }),
            )
            .subscribe()
    }

    public dismissBanner() {
        // no persistence. banner should re-open on refresh
        this.banner = null
        this.bannerSubject.next(null)
    }
}
